import React from "react";
import Chart from "react-apexcharts";
import { FiRefreshCw } from "react-icons/fi";

export default function PayrollCard() {
  const data = [
   300,300,300,300,300,300,300,300,300,300,300,300,300,300,300,300,300,300,300,300
  ];

  const chartOptions = {
    chart: {
      type: "bar",
      sparkline: { enabled: true },
    },
    colors: data.map((v, i) =>
      i < 14 ? "#4ade80" : "#e5e7eb"
    ),
    plotOptions: {
      bar: {
        columnWidth: "22%",
        borderRadius: 8,
      },
    },
    dataLabels: { enabled: false },
    tooltip: {
      custom: function ({ series, seriesIndex, dataPointIndex }) {
        return `
          <div class="custom-tooltip">
            <div class="tooltip-title">Total</div>
            <div class="tooltip-row">
              <span class="dot"></span>
              Payroll: <b>${series[seriesIndex][dataPointIndex]}</b>
            </div>
          </div>
        `;
      },
    },
    xaxis: {
      categories: Array(data.length).fill(""),
      labels: { show: false },
    },
    yaxis: { show: false },
    grid: { show: false },
  };

  const chartSeries = [{ data }];

  return (
    <>
      {/* ✅ INTERNAL CSS */}
      <style>{`
        .payroll-card {
          border-radius:5px;
          border: 2px solid #e5e7eb;
          overflow: hidden;
          position: relative;
          background: #fff;
          padding: 16px;
        }

        /* BACKGROUND WAVE */
        .bg-overlay {
          position: absolute;
          inset: 0;
          background-image: url("/assets/img/bg/dashboard-bg.png");
          background-repeat: no-repeat;
          background-size: 140%;
          background-position: top center;
          opacity: 0.08;
          pointer-events: none;
        }

        .header {
          display: flex;
          justify-content: space-between;
          align-items: center;
          margin-bottom: 16px;
        }

        .icon-box {
          width: 48px;
          height: 48px;
          background: #eef2f7;
          border-radius: 12px;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .icon-box img {
          width: 22px;
        }

        .refresh-btn {
          width: 38px;
          height: 38px;
          border-radius: 50%;
          background: #f1f3f7;
          display: flex;
          align-items: center;
          justify-content: center;
        }

        .title-text {
          font-size: 14px;
          color: #6b7280;
          margin-bottom: 4px;
        }

        .amount-text {
          font-size: 30px;
          font-weight: 700;
          color: #1f2937;
          display: flex;
          align-items: center;
        }

        .growth-circle {
          width: 24px;
          height: 24px;
          background: #22c55e;
          color: #fff;
          border-radius: 50%;
          margin-left: 8px;
          display: flex;
          align-items: center;
          justify-content: center;
          font-size: 12px;
        }

        .chart-wrapper {
          margin-top: 16px;
        }

        /* TOOLTIP */
        .custom-tooltip {
          background: #fff;
          padding: 10px 14px;
          border-radius: 12px;
          box-shadow: 0 10px 30px rgba(0,0,0,0.12);
        }

        .tooltip-title {
          font-size: 12px;
          color: #9ca3af;
          margin-bottom: 4px;
        }

        .tooltip-row {
          font-size: 14px;
          display: flex;
          align-items: center;
          gap: 6px;
        }

        .dot {
          width: 10px;
          height: 10px;
          background: #4ade80;
          border-radius: 50%;
        }

        /* MOBILE */
        @media (max-width: 576px) {
          .amount-text {
            font-size: 22px;
          }
        }
      `}</style>

      {/* CARD */}
      <div className="payroll-card h-100">
        <div className="bg-overlay"></div>

        <div className="header">
          <div className="icon-box">
            <img src="/assets/img/icons/title-icon-02.svg" alt="" />
          </div>

          <div className="refresh-btn">
            <FiRefreshCw size={16} />
          </div>
        </div>

        <p className="title-text">Total Payroll</p>

        <h2 className="amount-text">
          $2,458,900
          <span className="growth-circle">▲</span>
        </h2>

        <div className="chart-wrapper">
          <Chart
            options={chartOptions}
            series={chartSeries}
            type="bar"
            height={90}
          />
        </div>
      </div>
    </>
  );
}